<template>
    <div class="integration-content">
      <div class="integration-content-card">
        <header>
          <img src="@/assets/integrations/google-drive.svg" alt="Google Drive" />
          <div class="header-text">
            <h4>Google Drive</h4>
            <h5>Cloud Storage</h5>
          </div>
        </header>
        <div class="integration-content-card-body">
          <p class="description">
            Google Drive is a cloud storage and file sharing platform. With Google Drive integration, it is possible to:
          </p>

          <ul>
            <li>Attach and share files directly within your workspace</li>
            <li>Access and reference Drive documents from your projects</li>
          </ul>
        </div>
      </div>
    </div>
  </template>

  <script lang="ts">
  export default {
    name: 'GoogleDriveDescription',
  };
  </script>
